window.site = window.site || {};

/**
 * Init Book A Room related scripts
 * @class Site
 * @static
 */
site.BookARoom = (function BookARoom() {
  "use strict";

  /**
   * jQuery elements
   * @private
   */
  var $hallRoomButtons;
  var $halls;
  var $heroCta;

  /**
   * Has the class been initialized?
   * @private
   */
  var inited = false;

  /**
   * Initialize Swiper slider
   * @private
   */
  function initSwiper(container) {
    if (!container) return null;
    if (container.classList.contains('swiper')) return null;

    const images = Array.from(container.querySelectorAll('.hall-item-image-cell img'));
    if (images.length === 0) return null;

    // Save navigation buttons before clearing
    const prevBtn = container.querySelector('.swiper-button-prev');
    const nextBtn = container.querySelector('.swiper-button-next');

    const wrapper = document.createElement('div');
    wrapper.className = 'swiper-wrapper';

    images.forEach((img) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.appendChild(img.cloneNode(true));
      wrapper.appendChild(slide);
    });

    // Clear container
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    container.classList.add('swiper');
    container.appendChild(wrapper);

    // Re-add navigation buttons
    if (prevBtn) container.appendChild(prevBtn);
    if (nextBtn) container.appendChild(nextBtn);

    const swiper = new window.Swiper(container, {
      modules: [window.SwiperModules.Navigation],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
    });

    return swiper;
  }

  /**
   * Initialize hall CTA buttons to pre-populate form
   * @private
   */
  const initHallCta = () => {
    const hallCtas = document.querySelectorAll(".hall-item-cta");

    if (hallCtas.length === 0) {
      console.log("BookARoom: No hall CTA buttons found");
      return;
    }

    console.log(`BookARoom: Found ${hallCtas.length} hall CTA buttons`);

    hallCtas.forEach((cta) => {
      cta.addEventListener("click", (e) => {
        e.preventDefault();

        const roomId = cta.dataset.roomId;

        if (!roomId) {
          console.warn("BookARoom: No room ID found on CTA");
          return;
        }

        console.log("BookARoom: CTA clicked for room ID:", roomId);

        const form = document.querySelector(".hero-form");

        if (!form) {
          console.warn("BookARoom: Hero form not found");
          return;
        }

        form.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        setTimeout(() => {
          const roomSelect = form.querySelector('select[name="room"]');

          if (roomSelect) {
            roomSelect.value = roomId;
            console.log("BookARoom: Pre-selected room:", roomId);

            roomSelect.style.transition = "all 0.3s ease";
            roomSelect.style.boxShadow = "0 0 0 3px rgba(255, 184, 0, 0.3)";

            setTimeout(() => {
              roomSelect.style.boxShadow = "";
            }, 2000);
          } else {
            console.warn("BookARoom: Room select not found in form");
          }
        }, 800);
      });
    });
  };

  /**
   * Initialize hero CTA smooth scroll
   * @private
   */
  const initHeroCta = () => {
    const heroCta = document.querySelector(".hero-cta");

    if (!heroCta) {
      console.log("BookARoom: Hero CTA button not found");
      return;
    }

    console.log("BookARoom: Found hero CTA button, attaching scroll listener");

    heroCta.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const hallList = document.querySelector("#hall-list");

      if (!hallList) {
        console.warn("BookARoom: Hall list section not found");
        return;
      }

      console.log("BookARoom: Scrolling to hall list");

      hallList.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  /**
   * Initialize room selection buttons
   * @private
   */
  const initRoomSelection = () => {
    const hallRoomButtons = document.querySelectorAll(".hall-room-button");

    console.log(`BookARoom: Found ${hallRoomButtons.length} room buttons`);

    if (hallRoomButtons.length === 0) {
      return;
    }

    hallRoomButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();

        const roomIndex = button.dataset.roomIndex;
        const hallIndex = button.dataset.hall;

        console.log(
          "BookARoom: Button clicked - Room:",
          roomIndex,
          "Hall:",
          hallIndex,
        );

        const hall = document.querySelector(
          `.hall[data-hall-index="${hallIndex}"]`,
        );

        if (!hall) {
          console.error("BookARoom: Hall not found for index", hallIndex);
          return;
        }

        console.log("BookARoom: Found hall");

        hall
          .querySelectorAll(".hall-room-button")
          .forEach((btn) => btn.classList.remove("is-active"));
        button.classList.add("is-active");

        hall
          .querySelectorAll(".hall-item-header")
          .forEach((header) => header.classList.remove("is-active"));

        const selectedHeader = hall.querySelector(
          `.hall-item-header[data-room="${roomIndex}"][data-hall="${hallIndex}"]`,
        );
        if (selectedHeader) {
          console.log("BookARoom: Found header");
          selectedHeader.classList.add("is-active");
        }

        hall
          .querySelectorAll(".hall-item-content")
          .forEach((content) => content.classList.remove("is-active"));

        const selectedContent = hall.querySelector(
          `.hall-item-content[data-room="${roomIndex}"][data-hall="${hallIndex}"]`,
        );
        if (selectedContent) {
          console.log("BookARoom: Found content");
          selectedContent.classList.add("is-active");
        }

        hall
          .querySelectorAll(".hall-item-slider")
          .forEach((slider) => slider.classList.remove("is-active"));

        const selectedSlider = hall.querySelector(
          `.hall-item-slider[data-room="${roomIndex}"][data-hall="${hallIndex}"]`,
        );
        if (selectedSlider) {
          console.log("BookARoom: Found slider");
          selectedSlider.classList.add("is-active");

          const sliderContainer = selectedSlider.querySelector(".hall-gallery");
          if (sliderContainer && window.Swiper) {
            const swiperInstance = sliderContainer.swiper;
            if (swiperInstance) {
              console.log("BookARoom: Updating Swiper");
              setTimeout(() => {
                swiperInstance.update();
              }, 50);
            } else if (!sliderContainer.classList.contains('swiper')) {
              initSwiper(sliderContainer);
            }
          }
        }
      });
    });
  };

  /**
   * Initialize date and time input masks (REMOVED - using tail.DateTime instead)
   * @private
   */
  const initDateTimeMasks = () => {
    console.log("BookARoom: Date/time inputs handled by tail.DateTime");
  };

  /**
   * Initialize form validation (REMOVED - handled by HTML5 and tail.DateTime)
   * @private
   */
  const initFormValidation = () => {
    console.log("BookARoom: Form validation handled by HTML5 and server-side");
  };

  /**
   * Initialize Swiper sliders
   * @private
   */
  const initSwiperSliders = () => {
    const sliders = document.querySelectorAll(".hall-gallery");

    console.log(`BookARoom: Found ${sliders.length} sliders`);

    if (sliders.length === 0) {
      console.warn("BookARoom: No sliders found");
      return;
    }

    if (typeof window.Swiper === "undefined") {
      console.error("BookARoom: Swiper is not defined");
      return;
    }

    sliders.forEach((slider) => {
      if (slider.classList.contains("swiper")) {
        console.log("BookARoom: Slider already initialized, skipping");
        return;
      }

      console.log("BookARoom: Initializing Swiper on slider");
      initSwiper(slider);
    });
  };

  /**
   * Initializes the class.
   * @public
   */
  var init = function () {
    if (inited) {
      console.warn("BookARoom: Already initialized");
      return false;
    }

    console.log("BookARoom: Initializing...");
    inited = true;

    initHeroCta();
    initHallCta();
    initRoomSelection();
    initSwiperSliders();
    initDateTimeMasks();
    initFormValidation();

    console.log("BookARoom: Initialization complete");

    return true;
  };

  return {
    init: init,
  };
})();
